import { Panel } from "primereact/panel";
import { DadosDinamicos } from "./DadosDinamicos";

export default function RenunciasBeneficios({ renunciasBeneficios }: { renunciasBeneficios: any }) {
  if (!renunciasBeneficios) return null;

  return (
    <div>
      <Panel header="Empresas Habilitadas a Benefícios Fiscais">
        {renunciasBeneficios.erro ? (
          <p>{renunciasBeneficios.erro}</p>
        ) : (
          <DadosDinamicos dados={renunciasBeneficios} />
        )}
      </Panel>
    </div>
  );
}
